// features/auth/stores/auth.store.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import authService from '../services/auth.service';
import { 
  LoginCredentials, 
  RegisterCredentials,
  AuthResponse,
  User 
} from '../types/auth.types';

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  login: (credentials: LoginCredentials) => Promise<void>;
  register: (credentials: RegisterCredentials) => Promise<void>;
  logout: () => void;
  setAuthenticated: (value: boolean) => void;
  setUser: (user: User | null) => void;
}

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,

      setAuthenticated: (value: boolean) => {
        set({ isAuthenticated: value });
      },

      setUser: (user: User | null) => {
        set({ user });
      },

      login: async (credentials) => {
        try {
          const response = await authService.login(credentials);
          const user = await authService.getCurrentUser();
          set({ isAuthenticated: true, user });
        } catch (error) {
          set({ isAuthenticated: false, user: null });
          throw error;
        }
      },

      register: async (credentials) => {
        try {
          const response = await authService.register(credentials);
          const user = await authService.getCurrentUser();
          set({ isAuthenticated: true, user });
        } catch (error) {
          set({ isAuthenticated: false, user: null });
          throw error;
        }
      },

      logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        set({ isAuthenticated: false, user: null });
        window.location.href = '/';
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user
      })
    }
  )
);

export default useAuthStore;